import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createVNode as _createVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "product-price-details" }
const _hoisted_2 = {
  class: "product-price-details__hint",
  colspan: "2"
}
const _hoisted_3 = { class: "fs-regular" }
const _hoisted_4 = ["innerHTML"]
const _hoisted_5 = ["innerHTML"]
const _hoisted_6 = ["innerHTML"]

import BaseSpacer from '@/components/BaseSpacer.vue';
import {
  PropType,
  computed,
  ref,
  onMounted,
} from 'vue';

import { env, formatNumber, getNumberPrecision } from '@/helpers';
import { Product } from '@/classes';

import { library } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { faInfoCircle } from '@fortawesome/pro-light-svg-icons';


export default /*@__PURE__*/_defineComponent({
  __name: 'PriceDetailsTable',
  props: {
  product: {
    type: Object as PropType<Product>,
    required: true,
  },
},
  emits: ['subs'],
  setup(__props, { emit: __emit }) {

library.add(faInfoCircle);

const props = __props;
const emit = __emit;

const countSub = ref(1);

const rowsPrices = computed(() => {
  let rows: Array<Array<string | number | null | undefined>> = [];

  if (props.product.priceIsDouble) {
    rows = [...rows, ...[
      ['Preis pro kWh HT', `${props.product.getPriceFormatted('workingPriceHt')}&thinsp;Cent&nbsp;`],
      ['Preis pro kWh NT', `${props.product.getPriceFormatted('workingPriceNt')}&thinsp;Cent&nbsp;`],
    ]];
  } else {
    rows.push(['Arbeitspreis pro kWh', `${props.product.getPriceFormatted('workingPrice')}&thinsp;Cent&nbsp;`]);
  }

  if (props.product.category.key === 'gas') {
    const gasStorageSurcharge = env('GAS_STORAGE_SURCHARGE', 0) as number;
    rows.push(['exkl. Gasspeicherumlage<br>(§ 35 e EnWG)', `${formatNumber(gasStorageSurcharge, getNumberPrecision(gasStorageSurcharge))}&thinsp;ct/kWh`]);
  }

  rows = [...rows, ...[
    ['Grundpreis pro Monat', `${props.product.getPriceFormatted('basePrice')}&thinsp;€`],
    ['<b>Abschlag pro Monat</b>', `<b>${props.product.getPriceWithoutBonusFormatted('monthly')}&thinsp;€</b>`],
  ]];

  if (props.product.appliedBonuses.length) {
    rows.push(['Energiepreis pro Jahr<br>ohne Bonus', `${props.product.getPriceWithoutBonusFormatted('yearly')}&thinsp;€`]);

    const bonusKey = props.product.price?.params.customerType === 'business' ? 'bonus_value' : 'bonus_valueGross';

    props.product.appliedBonuses.forEach((bonus) => {
      rows.push([`<b class="color-primary">${bonus.name}</b>`, `${formatNumber(bonus[bonusKey], 5, true)}&thinsp;€`, bonus.info, countSub.value]);

      countSub.value += 1;
    });

    rows.push(['<b>Energiepreis pro Jahr<br>mit Bonus</br>', `${props.product.getPriceFormatted('yearly')}&thinsp;€`]);
  } else {
    rows.push(['<b>Energiepreis pro Jahr</b>', `<b>${props.product.getPriceFormatted('yearly')}&thinsp;€</b>`]);
  }

  return rows;
});

onMounted(() => {
  const subs: { sub: number, info: string }[] = [];

  rowsPrices.value.forEach((row) => {
    if (row.info && row.sub) {
      subs.push({
        sub: row.sub as number,
        info: row.info as string,
      });
    }
  });

  emit('subs', subs);
});

return (_ctx: any,_cache: any) => {
  const _component_IoTooltip = _resolveComponent("IoTooltip")!

  return (_openBlock(), _createElementBlock("table", _hoisted_1, [
    _createElementVNode("tr", null, [
      _createElementVNode("td", _hoisted_2, [
        _createTextVNode(" Alle Preise inkl. aktuell gültiger Umsatzsteuer" + _toDisplayString(__props.product.category.key === 'gas' ? '.' : ' und gesetzlicher Abgaben.') + " ", 1),
        _createVNode(BaseSpacer, { size: "s" })
      ])
    ]),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(rowsPrices.value, (row) => {
      return (_openBlock(), _createElementBlock("tr", {
        key: row[0]
      }, [
        _createElementVNode("td", _hoisted_3, [
          _createElementVNode("span", {
            innerHTML: row[0]
          }, null, 8, _hoisted_4),
          _createElementVNode("sup", {
            class: "d-none d-print-inline",
            innerHTML: row[3]
          }, null, 8, _hoisted_5),
          (row[2])
            ? (_openBlock(), _createBlock(_component_IoTooltip, {
                key: 0,
                class: "color-primary d-print-none"
              }, {
                title: _withCtx(() => [
                  _createTextVNode(_toDisplayString(row[2]), 1)
                ]),
                default: _withCtx(() => [
                  _createVNode(_unref(FontAwesomeIcon), { icon: "fa-light fa-info-circle" })
                ]),
                _: 2
              }, 1024))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("td", {
          class: "fs-regular",
          innerHTML: row[1]
        }, null, 8, _hoisted_6)
      ]))
    }), 128))
  ]))
}
}

})